import { render, staticRenderFns } from "./CustomerComplaintList.vue?vue&type=template&id=56ba7b65&scoped=true&"
import script from "./CustomerComplaintList.vue?vue&type=script&lang=js&"
export * from "./CustomerComplaintList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerComplaintList.vue?vue&type=style&index=0&id=56ba7b65&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ba7b65",
  null
  
)

export default component.exports